import React from 'react';
import ReactDOM from 'react-dom';
import SuccessStoriesTeaser from './SuccessStoriesTeaser';

window.Drupal.behaviors.successStories = {
    attach: async function (context) {
        const successStories = context.querySelectorAll('[data-success-stories-teaser]');
        if (successStories.length === 0) return;

        successStories.forEach((element) => {
            delete element.dataset.successStoriesTeaser;
            const script = element.querySelector('script');
            const stories = JSON.parse(script.innerHTML);
            script.remove();
            ReactDOM.render(React.createElement(SuccessStoriesTeaser, { stories }, []), element);
        });
    },
};
